import { render } from "./model-table.vue?vue&type=template&id=6b7fdb10"
import script from "./model-table.vue?vue&type=script&lang=js"
export * from "./model-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__